export default __webpack_public_path__ + "static/media/LINK.ddf07b1c.png";